export const UniversalLinkParser = (value) => {
    if (value === undefined || value === null || value === "") {
        return <span className="opacity-25">--</span>;
    }

    const stringValue = String(value);
    // Universal Regex: Finds all http/https URLs in any text block
    const urlPattern = /(https?:\/\/[^\s,;]+)/g;
    const matches = stringValue.match(urlPattern);

    if (!matches) return stringValue;

    return (
        <div className="py-1">
            <div className="text-wrap mb-1">{stringValue}</div>
            <div className="d-flex flex-wrap gap-1">
                {matches.map((url, i) => (
                    <a 
                        key={i} 
                        href={url} 
                        target="_blank"             // Opens in new tab
                        rel="noopener noreferrer"    // Unrelated window (Security)
                        className="btn btn-xs btn-outline-primary fw-bold px-2 py-0"
                        style={{ fontSize: '9px', lineHeight: '1.4' }}
                    >
                        <i className="bi bi-box-arrow-up-right me-1"></i>
                        {matches.length === 1 ? "VIEW REF" : `REF ${i + 1}`}
                    </a>
                ))}
            </div>
        </div>
    );
};